import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

export default function DropZone({ accept, multiple = false, onFiles, label, testId = "dropzone" }) {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);

  const onDrop = useCallback(
    (e) => {
      e.preventDefault();
      setActive(false);
      const files = Array.from(e.dataTransfer.files || []);
      if (files.length) onFiles(multiple ? files : [files[0]]);
    },
    [multiple, onFiles]
  );

  return (
    <label
      className={`dropzone ${active ? "active" : ""} block w-full p-12 sm:p-16 cursor-pointer text-center select-none rounded-md`}
      onDragOver={(e) => {
        e.preventDefault();
        setActive(true);
      }}
      onDragLeave={() => setActive(false)}
      onDrop={onDrop}
      data-testid={testId}
    >
      <input
        type="file"
        accept={accept}
        multiple={multiple}
        className="hidden"
        onChange={(e) => {
          const files = Array.from(e.target.files || []);
          if (files.length) onFiles(multiple ? files : [files[0]]);
          e.target.value = "";
        }}
        data-testid={`${testId}-input`}
      />
      <div className="flex flex-col items-center gap-3">
        <div className="w-12 h-12 grid place-items-center border border-zinc-300 rounded-md">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 19V5" />
            <path d="m5 12 7-7 7 7" />
          </svg>
        </div>
        <div className="hero-h2 text-xl sm:text-2xl">{label || t("drop_or_click")}</div>
        <div className="text-sm text-zinc-500">{t("formats_accepted")}</div>
      </div>
    </label>
  );
}
